<div
  *ngFor="let bounds of journeys$ | async; let index = index; let last = last; let first = first"
  class="upgrade-flight-block white-bg pr-medium border rounded-medium mobile-bleed"
  [class.mr-small-b]="!last"
>
  <fin-upgrade-journey-info [flightNumber]="index + 1" [isMultiCity]="(journeys$ | async).length > 2" [bounds]="bounds">
  </fin-upgrade-journey-info>

  <div class="bound-list">
    <fin-upgrade-bounds
      [bounds]="bounds"
      [paymentForm]="paymentForm"
      [selectedFlights]="selectedFlights$ | async"
      (changePaymentMethod)="paymentMethodChanged$.next($event)"
      (changeTabMethod)="flightTabChanged$.next($event)"
    >
    </fin-upgrade-bounds>
  </div>
</div>
